// extracted by mini-css-extract-plugin
module.exports = {"resizable":"PricesPanel_resizable__3v8Lo","loading":"PricesPanel_loading__3XqZ1","wrapper":"PricesPanel_wrapper__uGKJ3","first-row":"PricesPanel_first-row__-HR-o"};